/**
 * 埋点 使用fe-monitor
 * 业务使用方法：
 * 1. 直接调用 trackBehavior 方法
 *      trackBehavior({category: '菜单列表', name: '菜单点击数统计', value: '创建工单', action: 'click'});
 * 2. 使用原生自定义属性埋点(动态值使用该方法)
        <div
            data-track-category="选择产品"
            data-track-name="点击全部工单类型分类按钮"
            data-track-action="click"
            :data-track-value="allTypeVisible ? '展开' : '收起'"
        >123</div>
    3. 使用指令 v-track， 建议值复杂情况下采用指令，且值不是动态的。动态的需要使用原生自定义属性埋点
        v-track="{
            action: 'click', // 需要正确满足值是 addEventListener 的第一个参数
            category: '选择产品',
            name: '点击全部工单类型分类按钮',
            value: {id: 1, a:2, c:3},
        }"
    埋点行为规范记录文档 https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/ZXYdAhTZjt/T6mIlf81Vt/7nI3ZyBbGnpFF4
 */
import Monitor from '@baidu/fe-monitor';
import {getBaiduId} from '@/utils/cookie';
import ENV_CONFIG from '@/config';
const appTag = ENV_CONFIG.APP_TAG;
import store from '@/store';

// 由于需求要求知道具体是谁在操作，所以使用userId作为accountId上报
const getAccountId = () => store.getters.userInfo.userId || '';

export interface TrackBehaviorParams {
    name: string;
    action?: string;
    category?: string;
    value?: any;
}

export type TrackBehavior = (params: TrackBehaviorParams) => any;

const monitor: any = Monitor.init({
    baiduId: getBaiduId(),
    accountId: getAccountId(),
    appTag,
});

const trackBehavior: TrackBehavior = params => {
    const otherParams = {
        baiduId: getBaiduId(),
        accountId: getAccountId(),
        appTag,
    };
    const realParams: any = {
        ...params,
        action: params.action || 'click',
        ...otherParams,
    };

    Monitor.trackBehavior(realParams);
};

export const getMonitorCurrentPageView = () => {
    return monitor.page.getCurrentPage() || {};
};

export default trackBehavior;